module.exports = __webpack_public_path__ + "static/media/starterguide3v2.39ad7c0c.png";